<template>
	<div>
		<div class="container flex-start">
			<div class="search">
				<div class="flex-start">
					<div class="search_item">
						<div>审核状态：</div>
						<el-select v-model="reqOrderType" placeholder="请选择">
							<el-option v-for="item in orderTypeList" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="btn_warp">
					<div class="btn" @click="queryBtn">查询</div>
				</div>
			</div>
			<div v-loading="loading" class="req-warp">
				<div v-if="tableData.length > 0">
					<div class="req-warp">
						<el-table :data="tableData" border style="width: 100%">
							<el-table-column fixed align="center" label="申请人" width="200">
								<template slot-scope="scope">
									<div class="flex-center avatarwarp">
										<div class="avatar">
											<img :src="showAvatarUrl(scope.row.avatarUrl)"></img>
										</div>
										<div class="nickName">{{scope.row.nickName}}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="证件附件" width="160">
								<template slot-scope="scope">
									<div v-if="scope.row.hzattchList.length == 0">--</div>
									<el-image v-else style="width: 30px; height: 30px"
										:src="baseUrlpath + scope.row.hzattchList[0].sdua_filePath" @error="imgOnError"
										:preview-src-list="$util.previewSrcList(scope.row.hzattchList)">
									</el-image>
								</template>
							</el-table-column>
							<el-table-column prop="sdu_work" align="center" label="职业" width="120">
								<template slot-scope="scope">
									<el-button type="text" size="small"
										@click="viewWorkPicture(scope.row.workattchList)">{{scope.row.sdu_work}}
									</el-button>
								</template>
							</el-table-column>
							<el-table-column prop="sdu_realName" align="center" label="真实姓名" width="120">
							</el-table-column>
							<el-table-column prop="phoneNum" align="center" label="联系方式" width="140">
							</el-table-column>
							<el-table-column prop="optime" align="center" label="申请时间" width="180">
							</el-table-column>
							<el-table-column align="center" prop="realStt" label="审核状态" width="120">
								<template slot-scope="scope">
									<div>{{$util.getDisPlay(scope.row.realStt,$util.certifiList)}}</div>
								</template>
							</el-table-column>
							<el-table-column fixed="right" align="center" label="操作" width="200">
								<template slot-scope="scope">
									<div v-if="scope.row.realStt == '3'">
										<el-button @click="passCertification(scope.row)" type="text" size="small">审核通过
										</el-button>
										<el-button @click="rejectCertification(scope.row)" type="text" size="small">审核拒绝
										</el-button>
									</div>
									<div v-else>
										<el-button type="text">--</el-button>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination_warp">
						<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
							:page-size="pageSize" layout="total, prev, pager, next" :total="total">
						</el-pagination>
					</div>
				</div>
				<div v-else class="empty-msg">
					<el-empty description="暂无内容"></el-empty>
				</div>
			</div>
		</div>
		<div>
			<el-image ref="previewImg" style="width: 0px; height: 0px" :src="imgSrcUrl" @error="imgOnError"
				:preview-src-list="imgPreUrls">
			</el-image>
		</div>
		<el-dialog title="提示" :visible.sync="rejectDialogVisible" width="30%" center>
			<el-input type="textarea" :rows="4" placeholder="输入拒绝原因" v-model="rejectMsg" maxlength='100'
				show-word-limit></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelReject()">取 消</el-button>
				<el-button type="primary" @click="dealReject()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	export default {
		data() {
			return {
				currentPage1: 1,
				tableData: [],
				total: 0,
				pageSize: 9,
				baseUrlpath: '',
				reqType: 'all',
				reqTypeList: [],
				reqOrderType: 'all',
				orderTypeList: [],
				loading: false,
				defalutImg: require('@/assets/icon/noimg.jpg'),
				imgSrcUrl: '',
				imgPreUrls: [],
				rejectDialogVisible: false,
				rejectMsg: '',
				dealingId: ''
			}
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			this.reqTypeList = JSON.parse(JSON.stringify(this.$util.reqList));
			this.reqTypeList.unshift({
				'key': 'all',
				'value': '不限'
			})
			this.orderTypeList = JSON.parse(JSON.stringify(this.$util.xdOrderTypeList));
			this.orderTypeList.unshift({
				'key': 'all',
				'value': '不限'
			})
			this.query();
		},
		methods: {
			handleCurrentChange(e) {
				// console.log(e)
				this.currentPage1 = e;
				this.tableData = [];
				this.total = 0;
				this.query()
			},
			viewWorkPicture(attalist) {
				// console.log(attalist)
				if (attalist == undefined || attalist.length == 0) {
					this.$util.warnMsg('无附件');
				} else {
					this.imgSrcUrl = attalist[0].sdua_filePath
					this.imgPreUrls = []
					for (var index in attalist) {
						this.imgPreUrls.push(attalist[index].sdua_filePath)
					}
					this.$refs.previewImg.showViewer = true;
				}
			},
			imgOnError(e) {
				const img = e.srcElement;
				img.src = this.defalutImg;
				img.onerror = null
			},
			handleComfireClick() {

			},
			queryBtn() {
				this.currentPage1 = 1;
				this.query();
			},
			query() {
				this.loading = true
				var vm = this;
				var params = {};
				params.currentPage = vm.currentPage1;
				params.pageSize = vm.pageSize;
				queryUrl("/apis/getCertifications", params).then(res => {
					this.loading = false
					vm.tableData = res.reList;
					vm.total = res.totalNum;
				});
			},
			goToDetail(itemInfo) {
				this.$router.push({
					name: 'reqDetail',
					query: {
						reqNo: itemInfo.sdr_reqId
					}
				});
			},
			showAvatarUrl(avatarUrl) {
				if (avatarUrl) {
					if (avatarUrl.indexOf('http') >= 0) {
						return avatarUrl;
					} else {
						return this.baseUrlpath + avatarUrl;
					}
				}
			},
			passCertification(info) {
				var vm = this;
				this.$confirm('是否确定审核通过？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					vm.dealPass(info);
				})
			},
			async dealPass(info) {
				var params = {};
				params.certiId = info.userId
				const initres = await doPost("/apis/passCertification", params);
				if (initres.ec == '0') {
					this.$util.msg("审核通过成功");
					this.query();
				}
			},
			cancelReject() {
				this.rejectDialogVisible = false
				this.rejectMsg = ""
			},
			async dealReject() {
				if (this.rejectMsg.length == 0) {
					this.$util.warnMsg("请输入拒绝原因");
					return;
				}
				var vm = this;
				var params = {};
				params.certiId = this.dealingId
				params.rejectMsg = this.rejectMsg;
				const initres = await doPost("/apis/rejectCertification", params);
				if (initres.ec == '0') {
					this.$util.msg("审核拒绝成功");
					this.query();
					this.rejectDialogVisible = false
					this.rejectMsg = ""
				}
			},
			rejectCertification(info) {
				this.rejectDialogVisible = true
				this.dealingId = info.userId
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.req-warp {
		width: 100%;

		.avatarwarp {
			.avatar {
				width: 30px;
				height: 30px;
				overflow: hidden;
				border-radius: 50px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.nickName {
				font-size: 12px;
				padding-left: 26px;
				width: 100px;
				text-align: left;
			}
		}
	}

	.container {
		width: 90%;
		margin: 0 auto;
		align-items: flex-start;
		flex-direction: column;
		.pagination_warp {
			padding: 0 20px 20px 0;
			margin-top: 60px;
			width: 100%;
		}
		.empty-msg {
			flex: 1;
			height: calc(100vh - 70px);
			display: flex;
			justify-content: center;
			width: 100%;
		}

		.search {
			margin-top: 20px;
			margin-bottom: 30px;
			display: flex;
			align-items: center;

			.search_item {
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}

			.search_item:not(:first-child) {
				margin-left: 26px;
			}

			.btn_warp {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				margin-left: 20px;

				.btn {
					background-color: #C88854;
					color: #FFFFFF;
					width: 80px;
					margin: 0 10px;
					padding: 6px 0;
					border-radius: 20px;
					font-size: 14px;
					cursor: pointer;
				}

				.rest_btn {
					border: 1px solid #C88854;
					color: #C88854;
					width: 80px;
					margin: 0 10px;
					padding: 6px 0;
					border-radius: 20px;
					font-size: 14px;
					cursor: pointer;
				}
			}
		}
	}

	.req-item {
		border-radius: 8px;
		box-shadow: 0px 4px 16px 1px rgba(0, 0, 0, 0.06);
		overflow: auto;
		margin-right: 12px;
		margin-bottom: 12px;
		padding: 20px 20px;
	}
</style>
